import { render, staticRenderFns } from "./registerNoLogin.vue?vue&type=template&id=2a9b11c2&scoped=true&"
import script from "./registerNoLogin.vue?vue&type=script&lang=js&"
export * from "./registerNoLogin.vue?vue&type=script&lang=js&"
import style0 from "./registerNoLogin.vue?vue&type=style&index=0&id=2a9b11c2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9b11c2",
  null
  
)

export default component.exports